import {useEffect, useState} from "react";

import {withCache} from "../cache";
import {useApi} from "../PlayMakersProvider";

type FetchTagsMethod = (quiet?: boolean) => Promise<string[]>;

interface UseTagsReturn {
  refresh:FetchTagsMethod;
  fetched: boolean;
  tags: string[];
}

export const useTags = (projectId: any, params: {[key:string]: any}): UseTagsReturn => {
  const {getTags} = useApi();
  const [tags, setTags] = useState<string[]>([]);
  const [fetched, setFetched] = useState<boolean>(false);

  // Fetch the tags of a projectId from the backend
  // projectId can be undefined
  const fetchTags:FetchTagsMethod = async(quiet: boolean = false) => {
    setFetched(quiet);
    try {
      const tags = await withCache(getTags, [projectId, params], 300_000);
      setTags(tags);
      return tags;
    } catch (error) {
      console.error("Error fetching tags", error);
      throw new Error("Error fetching tags", {cause: error});
    } finally {
      setFetched(true);
    }
  };

  useEffect(() => {
    fetchTags();
  }, [projectId, params?.page]);

  return {
    fetched,
    refresh: fetchTags,
    tags
  };
};
